import * as React from "react";
import styled from "styled-components";

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: var(--footer-min-height);
  padding: var(--mb-2);
  text-align: center;

  .footer-credit {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
    font-weight: Var(--font-semi);
    margin-bottom: var(--mb-1);
  }

  .footer-attribute {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
  }
`;

const Footer = () => {
  return (
    <StyledFooter>
      <p className="footer-credit">Designed & Built with <span role="img" aria-label = "emoji">💖</span> by Low Zi Jian</p>
      <p className="footer-attribute">
        Inspired by{" "}
        <a
          className="highlighted-context"
          href="https://brittanychiang.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Brittany Chiang
        </a>
      </p>
    </StyledFooter>
  );
};

export default Footer;
